import { ICellRendererParams } from 'ag-grid-community';

import { WorkflowVisualization } from '../../workflow/visualization/WorkflowVisualization';
import {
  isWorkflowVisualizationData,
  WorkflowStepFile,
  WorkflowVisualizationData,
} from '../../workflow/visualization/workflowVisualizationModel';
import { EMPTY_VALUE } from '../valueFormatters';

import { DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED } from './constants';

interface IWorkflowVisualizationCellRendererParams<TData = unknown>
  extends ICellRendererParams<TData, WorkflowVisualizationData> {
  onFileClick?: (file: WorkflowStepFile) => void;
}

export function WorkflowVisualizationCellRenderer({
  formatValue,
  onFileClick,
  value,
}: IWorkflowVisualizationCellRendererParams) {
  if (value === undefined) {
    return;
  }

  if (value == null) {
    return formatValue?.(value) ?? EMPTY_VALUE;
  }

  if (!isWorkflowVisualizationData(value)) {
    throw new Error(
      `WorkflowVisualizationCellRenderer called with wrong data format: ${JSON.stringify(value, null, 2)}`
    );
  }

  return (
    <div
      {...DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED}
      data-testid="workflow-visualization-cell"
    >
      <WorkflowVisualization {...value} onFileClick={onFileClick} />
    </div>
  );
}
